/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.preload)();
	  (0, _module.anchorLink)();
	  (0, _module.scrollAnime)();
	  (0, _module.loadAnime)();
	  (0, _module.countDown)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.countDown = exports.loadAnime = exports.scrollAnime = exports.anchorLink = exports.preload = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	var videoControl = function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	}; // ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var preload = function preload() {
	  $(window).on("load", function () {
	    $("body").removeClass("preload");
	    $("body").css("opacity", "");
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// scrollAnime
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var scrollAnime = function scrollAnime() {
	  var margin = 0;
	
	  if (matchMedia('(max-width: 768px)').matches) {
	    margin = 200;
	  } else {
	    margin = 500;
	  }
	
	  $(".js-sc").each(function (i, node) {
	    gsap.to(node, {
	      scrollTrigger: {
	        trigger: node,
	        start: 'top bottom-=' + margin,
	        toggleClass: {
	          targets: node,
	          className: "animated"
	        },
	        once: true
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// loadAnime
	// ------------------------------------------------------------------------
	
	
	exports.scrollAnime = scrollAnime;
	
	var loadAnime = function loadAnime() {
	  $(window).on("load", function () {
	    $(".js-ld").toggleClass("animated");
	  });
	}; // ------------------------------------------------------------------------
	// countDown
	// ------------------------------------------------------------------------
	
	
	exports.loadAnime = loadAnime;
	
	var cd = function cd(date, nowDate, durDate) {
	  var countDownDate = date;
	  var now = nowDate;
	  var duration = durDate;
	  var days = Math.floor(duration / (1000 * 60 * 60 * 24));
	  var hours = Math.floor(duration % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
	  var minutes = Math.floor(duration % (1000 * 60 * 60) / (1000 * 60));
	  var seconds = Math.floor(duration % (1000 * 60) / 1000);
	  days = String(days).padStart(2, '0');
	  hours = String(hours).padStart(2, '0');
	  minutes = String(minutes).padStart(2, '0');
	  seconds = String(seconds).padStart(2, '0');
	  document.getElementById("main-cd_text").innerHTML = "<span>" + days + "</span><span class='main-cd_c'>:</span><span>" + hours + "</span><span class='main-cd_c'>:</span><span>" + minutes + "</span><span class='main-cd_c'>:</span><span>" + seconds + "</span>";
	
	  if (duration < 0) {
	    document.getElementById("main-cd_text").innerHTML = "<span>00</span><span class='main-cd_c'>:</span><span>00</span><span class='main-cd_c'>:</span><span>00</span><span class='main-cd_c'>:</span><span>00</span>";
	  }
	};
	
	var countDown = function countDown() {
	  var countDownDate = new Date("May 26, 2022 11:00:00").getTime();
	  var nowFirst = new Date().getTime();
	  var durFirst = countDownDate - nowFirst;
	  cd(countDownDate, nowFirst, durFirst);
	  var i = setInterval(function () {
	    var nowCount = new Date().getTime();
	    var durCount = countDownDate - nowCount;
	    cd(countDownDate, nowCount, durCount);
	
	    if (durCount < 0) {
	      clearInterval(i);
	    }
	  }, 1000);
	};
	
	exports.countDown = countDown;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.bundle.js